import { useParams } from 'react-router-dom'

import { useGetDivvyUUID } from '@sputnik/pages/gql/GetDivvyUUID.gql'

const useDivvyUUID = (appId?: string): [string, { loading: boolean }] => {
  const { appId: appIdParam } = useParams()
  const creditApplicationId = appId || appIdParam || ''
  const { data, loading } = useGetDivvyUUID({ variables: { creditApplicationId } })
  const companyDivvyUuid = data?.creditApplication?.companyDivvyUuid
  return [companyDivvyUuid ?? '', { loading }]
}

export default useDivvyUUID
